import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import SaveSectionPositionsGql from '@/store/graphql/cms/mutations/SaveSectionPositions.gql';
import CreateSectionGql from '@/store/graphql/cms/mutations/CreateSection.gql';
import UpdateSectionGql from '@/store/graphql/cms/mutations/UpdateSection.gql';
import DeleteSectionGql from '@/store/graphql/cms/mutations/DeleteSection.gql';
import CloneSectionGql from '@/store/graphql/cms/mutations/CloneSection.gql';

// Reine Anzeige-Felder, die die Mediathek (ImageLibraryDialog / buildSelectedImage)
// am Bild-Objekt hängt, aber nicht Teil von CP_ImageInput sind (u.a. url, signed_url,
// visibility) -> vor dem Speichern entfernen. Rekursiv, auch für verschachtelte Contents.
const cleanContentImages = contents => {
    (contents || []).forEach(content => {
        (content.images || []).forEach(image => {
            if (!image) return;
            delete image.url;
            delete image.signed_url;
            delete image.visibility;
            if (image.source) {
                delete image.source.url;
                delete image.source.description;
            }
        });
        if (content.contents) cleanContentImages(content.contents);
    });
};

export default {
    saveMany: sections => {
        if (sections === undefined) throw new Error('required argument is missing');

        sections = _.removeDeepByKey(sections, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveSectionPositionsGql,
                    variables: { sections }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_SaveSections);
                })
                .catch(err => reject(err));
        });
    },
    create: (section, cms) => {
        if (section === undefined || cms === undefined) throw new Error('required argument is missing');

        section = _.removeDeepByKey(section, '__typename');
        delete section.loading

        cleanContentImages(section.contents)

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateSectionGql,
                    variables: {
                        section,
                        cms: { id: parseInt(cms.id) }
                    }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_CreateSection);
                })
                .catch(err => reject(err));
        });
    },
    update: section => {
        if (section === undefined) throw new Error('required argument is missing');

        section = _.removeDeepByKey(section, '__typename');
        delete section.loading

        cleanContentImages(section.contents)

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateSectionGql,
                    variables: { section }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_UpdateSection);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteSectionGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_DeleteSection);
                })
                .catch(err => reject(err));
        });
    },
    clone: (sectionId, pageId, position, gridAreaId, area) => {
        if (sectionId === undefined || pageId === undefined || position === undefined) {
            throw new Error('required argument is missing');
        }

        const variables = {
            sectionId: parseInt(sectionId),
            pageId: parseInt(pageId),
            position: parseInt(position),
        };

        if (gridAreaId) {
            variables.gridAreaId = parseInt(gridAreaId);
        }

        if (area) {
            variables.area = area;
        }

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CloneSectionGql,
                    variables,
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_CloneSection || []);
                })
                .catch(err => reject(err));
        });
    },
    noDeleteDialog: (value, type = 'section') => {
        if (value !== undefined) {
            localStorage.setItem(`no-delete-dialog:${type}`, value);
        } else {
            return localStorage.getItem(`no-delete-dialog:${type}`);
        }
    }
};
